import { useEffect, useState } from 'react'

import { useMessages } from '@/modules/messages/hooks/useMessages'
import { DataTable } from '@/shared/components/data-table/DataTable'

import { salesColumns } from '../../constants/salesColumns'
import { useSales } from '../../hooks/useSales'

const PAGE_SIZE = 5

export function SalesTable({
  onEdit,
  onDelete,
  onMessage,
  onAssignTarget,
  onViewTargets,
}) {
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const { sales, meta, fetchSales, isLoading } = useSales()
  const { unreadCounts } = useMessages()

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim())
      setPage(1)
    }, 300)
    return () => clearTimeout(timer)
  }, [search])

  useEffect(() => {
    fetchSales({
      page,
      limit: PAGE_SIZE,
      ...(debouncedSearch ? { search: debouncedSearch } : {}),
    })
  }, [fetchSales, page, debouncedSearch])

  return (
    <DataTable
      columns={salesColumns(
        onEdit,
        onDelete,
        onMessage,
        unreadCounts.bySender,
        onAssignTarget,
        onViewTargets,
      )}
      data={sales}
      loading={isLoading}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: 'Search by name, email or phone number...',
      }}
      filterSummary={`${sales.length} of ${meta?.total ?? sales.length}`}
      pagination={{
        page,
        pageSize: PAGE_SIZE,
        total: meta?.total ?? sales.length,
        onPageChange: setPage,
      }}
    />
  )
}
